import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const RetailCard = ({ name, cta, icon, href, delay }) => {
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 15 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay }}
      whileHover={{ y: -4, scale: 1.02 }}
      className="flex flex-col items-center justify-center p-6 bg-white border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 rounded-2xl group text-center h-full"
    >
      <div className="w-14 h-14 mb-4 rounded-full bg-brand-teal/5 flex items-center justify-center text-brand-teal group-hover:bg-brand-teal group-hover:text-white transition-all duration-500">
        <SafeIcon icon={icon} className="text-2xl" />
      </div>
      
      <h3 className="font-bold text-brand-dark text-lg mb-4">{name}</h3>
      
      <div className="mt-auto w-full">
        <span className="inline-flex items-center justify-center w-full px-4 py-2.5 bg-gray-50 text-gray-700 text-[10px] font-black uppercase tracking-widest rounded-lg group-hover:bg-brand-dark group-hover:text-white transition-colors duration-300 border border-gray-100 group-hover:border-brand-dark">
          {cta}
        </span>
      </div>
    </motion.a>
  );
};

export default RetailCard;